import { api, API_URL } from "./paths";
import { Statistics } from "../types/statistics";

const axios = require("axios");

export async function getStatisticsForHospitalByYear(
  hospitalId: number,
  year: number
) {
  return axios.get(
    `${API_URL}/rode/hospitals/${hospitalId}/statistics/${year}`
  );
}

export async function getStatisticsFields() {
  return axios.get(api.STATISTICSFIELDS_URL);
}

export async function saveStatisticsForHospital(
  hospitalId: number,
  statistics: Statistics
) {
  return axios.post(
    `${API_URL}/rode/hospitals/${hospitalId}/statistics`,
    statistics
  );
}

export async function updateStatisticsForHospitalByYear(
  hospitalId: number,
  year: number,
  statistics: Statistics
) {
  return axios.put(
    `${API_URL}/rode/hospitals/${hospitalId}/statistics/${year}`,
    statistics
  );
}
